// ============================================================================
// ARABIC TRANSLATIONS - UI (العربية)
// RTL Language - Right-to-Left
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'ar',
    languageName: 'العربية',
    version: '1.0',
    direction: 'rtl'
  },
  
  app: {
    title: "UNITYQUEST سجلات\nالحب",
    subtitle: "اكتشاف تفاعلي للكتب المقدسة",
    tagline: "السير نحو النور الإلهي",
    menu: "القائمة",
    retry: "إعادة المحاولة"
  },
  
  buttons: {
    play: "العب",
    back: "رجوع",
    continue: "استمر",
    restart: "ابدأ من جديد",
    close: "إغلاق",
    nextLevel: "المستوى التالي",
    selectLevel: "اختيار المستوى",
    retry: "أعد المحاولة",
    mainMenu: "القائمة الرئيسية",
    start: "ابدأ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    save: "حفظ",
    load: "تحميل",
    yesRestart: "نعم، أعد البدء",
    noContinue: "لا، استمر",
    tryAgain: "حاول مرة أخرى",
    backToMenu: "العودة إلى القائمة"
  },
  
  labels: {
    score: "النقاط",
    stars: "النجوم",
    wisdom: "الحكمة",
    revelation: "الوحي",
    lives: "الأرواح",
    combo: "كومبو",
    level: "المستوى",
    easy: "سهل",
    medium: "متوسط",
    hard: "صعب",
    correct: "صحيح!",
    gameOver: "فشل الاختبار",
    victory: "النصر!",
    completed: "مكتمل",
    rank: "الرتبة الروحية",
    points: "نقاط الحكمة",
    unlockedLevels: "مستويات مفتوحة",
    questionOfKnowledge: "سؤال المعرفة",
    hintOfWisdom: "تلميح الحكمة",
    knowledgeMastered: "تم إتقان المعرفة!",
    knowledgeAcquired: "تم اكتساب المعرفة!",
    testFailed: "فشل الاختبار",
    wisdomBonus: "مكافأة",
    xpGained: "نقاط الخبرة",
    newRank: "رتبة جديدة",
    nextGrade: "الدرجة التالية",
    maxLevelReached: "تم الوصول إلى المستوى الأقصى!",
    wrongAnswer: "إجابة خاطئة!"
  },
  
  menu: {
    playButton: "العب",
    info: "معلومات",
    treasures: "الكنوز",
    john: "يوحنا",
    reset: "إعادة تعيين",
    resetConfirm: "إعادة بدء المغامرة؟",
    resetWarning: "هل أنت متأكد من أنك تريد مسح جميع تقدمك؟",
    resetLose: "سوف تفقد:",
    wisdomPoints: "نقاط الحكمة",
    starsCollected: "النجوم المجموعة",
    levelsUnlocked: "المستويات المفتوحة",
    spiritualRank: "الرتبة الروحية",
    yesRestart: "نعم، ابدأ من جديد",
    noContinue: "لا، استمر",
    newAdventure: "مغامرة جديدة",
    readyToStart: "هل أنت مستعد للبدء؟",
    startJourney: "ابدأ رحلتك في معرفة الكتب المقدسة!",
    audioControls: "عناصر التحكم الصوتية",
    mute: "كتم الصوت",
    unmute: "تشغيل الصوت",
    close: "إغلاق",
    language: "اللغة",
    restartGame: "إعادة تشغيل اللعبة"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "مغامرة كتابية تفاعلية",
    anonymousMode: "العب بدون اسم",
    anonymousDesc: "اختر اسم مستعار",
    emailMode: "تسجيل الدخول بالبريد",
    emailDesc: "حفظ متعدد الأجهزة",
    pseudo: "اسم مستعار",
    pseudoPlaceholder: "اسمك المستعار...",
    email: "عنوان البريد الإلكتروني",
    emailPlaceholder: "your@email.com",
    startPlaying: "ابدأ اللعب",
    sendLink: "إرسال الرابط",
    sending: "جاري الإرسال...",
    connecting: "جاري الاتصال...",
    back: "رجوع",
    localSave: "سيتم حفظ تقدمك محليًا",
    cloudSync: "لا حاجة لكلمة مرور • مزامنة السحابة",
    magicLink: "احصل على رابط سحري عبر البريد الإلكتروني",
    checkEmail: "✉️ تحقق من بريدك الإلكتروني! تم إرسال رابط تسجيل الدخول.",
    checkSpam: "تحقق أيضًا من مجلد الرسائل غير المرغوب فيها",
    waitingConnection: "في انتظار الاتصال...",
    errorSend: "خطأ في إرسال الرابط",
    rateLimited: "⏳ يرجى الانتظار 15 ثانية قبل إعادة إرسال بريد إلكتروني",
    importSession: "🔄 استيراد الجلسة من الإنتاج",
    errorConnection: "خطأ في الاتصال",
    enterPseudo: "الرجاء إدخال اسم مستعار",
    enterEmail: "الرجاء إدخال بريد إلكتروني صالح",
    // Tooltips
    never: "أبداً",
    save: "حفظ اللعبة",
    lastSave: "آخر",
    refresh: "إعادة تحميل التقدم",
    logout: "تسجيل الخروج",
    connectToCloud: "اتصل للحفظ عبر الإنترنت",
    editPseudo: "تعديل اسم المستخدم",
    confirm: "تأكيد",
    cancel: "إلغاء",
    close: "إغلاق",
    passwordMode: "تسجيل دخول بسيط",
    passwordDesc: "البريد الإلكتروني + كلمة المرور",
    password: "كلمة المرور",
    passwordPlaceholder: "6 أحرف على الأقل",
    passwordMinLength: "6 أحرف على الأقل",
    playWithoutAccount: "اللعب بدون حساب",
    forgotPassword: "هل نسيت كلمة المرور؟",
    resetPasswordTitle: "إعادة تعيين كلمة المرور",
    resetPasswordSubtitle: "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين",
    sendResetLink: "إرسال الرابط",
    resetEmailSent: "📧 تم إرسال بريد إعادة التعيين! تحقق من بريدك الوارد.",
    errorReset: "خطأ في إرسال البريد الإلكتروني",
    backToSignin: "العودة إلى تسجيل الدخول",
    newPassword: "كلمة مرور جديدة",
    enterNewPassword: "اختر كلمة مرور آمنة جديدة",
    confirmPassword: "تأكيد كلمة المرور",
    updatePassword: "تحديث كلمة المرور",
    passwordsDontMatch: "كلمات المرور غير متطابقة",
    passwordUpdateSuccess: "✅ تم تحديث كلمة المرور بنجاح!",
    errorUpdatePassword: "خطأ في تحديث كلمة المرور",
    resetLinkExpired: "انتهت صلاحية رابط إعادة التعيين أو غير صالح",
    forgotPassword: "هل نسيت كلمة المرور؟",
    signup: "تسجيل",
    signin: "تسجيل الدخول",
    createAccount: "إنشاء حساب",
    signupInfo: "املأ النموذج أدناه",
    passwordInfo: "وصول سريع باستخدام كلمة المرور",
    signupButton: "إنشاء حسابي",
    signinButton: "تسجيل الدخول",
    passwordTooShort: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
    emailAlreadyExists: "هذا البريد الإلكتروني مستخدم بالفعل",
    emailExistsHint: "✉️ هذا البريد الإلكتروني مسجل بالفعل. حاول تسجيل الدخول! (ربما تم إنشاؤه من لعبة أخرى؟)",
    switchToSignin: "🔑 انتقل إلى وضع تسجيل الدخول باستخدام بريدك الإلكتروني الحالي",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    signupSuccess: "📧 تم إنشاء الحساب! تحقق من بريدك الإلكتروني لتأكيد التسجيل.",
    emailConfirmationRequired: "تحقق من صندوق الوارد لتفعيل حسابك",
    checkSpamFolder: "تذكر التحقق من مجلد الرسائل غير المرغوب فيها",
    connectionSuccess: "✅ تم تسجيل الدخول بنجاح!",
    errorSignup: "خطأ أثناء التسجيل"},
  
  install: {
    title: "تثبيت التطبيق",
    subtitle: "وصول سريع وغير متصل",
    feature1: "إطلاق فوري من شاشتك الرئيسية",
    feature2: "يعمل دون اتصال بعد التثبيت",
    feature3: "تجربة تطبيق أصلي",
    feature4: "لا حاجة لتنزيل المتجر",
    install: "تثبيت",
    dismiss: "لاحقاً",
    info: "يمكنك إلغاء تثبيت التطبيق في أي وقت"
  },
  
  ranks: {
    seeker: "باحث",
    believer: "المستيقظ",
    disciple: "تلميذ",
    servant: "خادم",
    witness: "شاهد",
    guardian: "حارس",
    wise: "حكيم",
    prophet: "نبي",
    apostle: "رسول",
    seekerDesc: "بداية الرحلة الروحية",
    believerDesc: "الوعي الروحي المستيقظ",
    discipleDesc: "تعلم التعاليم",
    servantDesc: "الخدمة والتفاني",
    witnessDesc: "مشاركة الإيمان",
    guardianDesc: "حماية الحقيقة",
    wiseDesc: "الحكمة والمعرفة",
    prophetDesc: "الرؤية الروحية",
    apostleDesc: "معلم روحي"
  },

  spiritualJourney: {
    beginning: "بداية الرحلة الروحية",
    progress: "التقدم الروحي",
    grade: "الدرجة",
    xp: "نقاط الخبرة",
    level: "المستوى",
    nextGrade: "الدرجة التالية",
    still: "باقي",
    maxLevelReached: "تم الوصول إلى المستوى الأقصى!",
    masteredAllTeachings: "لقد أتقنت جميع التعاليم",
    progression: "التقدم"
  },
  
  treasures: {
    title: "💎 كنوز الكتاب المقدس",
    verse: "آية اليوم",
    fact: "هل تعلم؟",
    treasure: "كنز مخفي",
    question: "سؤال مضحك",
    context: "السياق",
    strongReference: "مرجع كتابي للدراسة المتعمقة",
    verseOfDay: "✨ آية اليوم",
    didYouKnow: "🌟 هل تعلم؟",
    hiddenTreasure: "📜 كنز مخفي",
    funnyQuestion: "🤔 سؤال مضحك",
    emmanuelMemo: "مذكرة عمانوئيل",
    emmanuelMessage: "لقد وصلت إلى قمة الجبل، والمعرفة مكتسبة. لكن الإيمان الراسخ يتطلب خبرة حياتية ورحمة وحب حقيقي ليسوع. ستختبر تجارب الحياة المختلفة طريقك، الطريق الحقيقي الذي نختاره، قلبنا. نبقى غير كاملين، رغباتنا عديدة، وحب الكسب أو راحتنا الشخصية يصبح في كثير من الأحيان أولويتنا الأنانية. اسأل الله الحكمة ومحبته وقوته، واعترف بتواضع بنقاط ضعفك، لأنه لا يمكن إخفاء أي شيء عنه... لا شيء. لا داعي للسفر في الوضع الخاص أو استخدام VPN أو حتى حذف السجل. صوموا مثل دانيال: احرموا أنفسكم للحظة مما تحبونه أكثر، في الهدوء والحكمة. سيسمح لك هذا بسماع الله بشكل أفضل، والحصول على استعداد قلبي جاهز للتحولات العميقة - والمؤلمة في كثير من الأحيان. عندها ستصبح الأحلام والرؤى أكثر وضوحًا، مثل يوسف. لكن احذر من الكبرياء: لا تستسلم لـ 'أنا دائمًا على حق' أو 'أنا أعرف أفضل'. لأن إعلان الله نعمة استثنائية. لا تصبح معلمًا للناموس، قادرًا على صلب يسوع مرة أخرى اليوم، الذي يطلب ببساطة أن تحب قريبك... وتمنحه نفس الحرية التي تتلقاها. امتلاك الإيمان يعني الدخول في علاقة حرة ورحلة القلب. سيجعلك أبطالًا أقوياء، قادرين على المستحيل. لأن تجربة الخارق للطبيعة، حضور الله، تأكيده أو بركته ستجعلك راسخًا حقًا.",
    jesusIsNot: "❌ توضيح مهم",
    clarification: "توضيح مهم",
    bibleOffline: "اقرأ الكتاب المقدس بدون اتصال",
    bibleStudy: "الدراسة الكتابية",
    version: "النسخة",
    openReader: "افتح القارئ",
    features: "المزايا"
  },
  
  messages: {
    chooseCard: "⚡ اختر بطاقة القوة",
    cardHelp: "ستصاحبك في الأسئلة الثلاثة لهذا المستوى",
    chooseAnswer: "📖 اختر إجابتك:",
    wrongAnswer: "❌ إجابة خاطئة! لديك {lives} حياة متبقية. حاول مرة أخرى!",
    levelCompleted: "المستوى {level} مكتمل",
    questionsProgress: "السؤال {current} من 3",
    starsCollected: "النجوم المجموعة: {current}/{total}",
    pointsEarned: "+{points} نقاط الحكمة",
    defeatedQuote: "أستطيع كل شيء في المسيح الذي يقويني",
    chapter: "فصل",
    chapterStars: "نجوم الفصل",
    totalGlobal: "المجموع الكلي",
    backToMenu: "العودة للقائمة"
  },
  
  quotes: {
    wisdom: "مخافة الرب رأس الحكمة",
    faith: "أستطيع كل شيء في المسيح الذي يقويني",
    hope: "الرب راعي فلا يعوزني شيء",
    love: "لأنه هكذا أحب الله العالم...",
    perseverance: "الإيمان يتطلب المثابرة",
    defeat: "الفشل يدعو للنمو في المعرفة"
  },

  cards: {
    faith: "الإيمان",
    courage: "الشجاعة",
    wisdom: "الحكمة",
    faithKnowledge: "+50% نقاط",
    courageKnowledge: "فرصة ثانية",
    wisdomKnowledge: "تلميح + مكافأة",
    faithDesc: "الحد الأقصى من نقاط الحكمة المكتسبة",
    courageDesc: "نقاط عادية ولكن فرصة ثانية",
    wisdomDesc: "تلميح مكشوف و +25% نقاط",
    chooseCard: "✨ اختر بطاقة المعرفة",
    cardEffects: "✨ تأثيرات بطاقات المعرفة:",
    faithEffect: "+50% نقاط حكمة - أقصى مكافأة",
    courageEffect: "نقاط عادية ولكن فرصة ثانية عند الخطأ",
    wisdomEffect: "+25% نقاط + تلميح مكشوف لكل سؤال",
    chooseWisely: "اختر بحكمة، لأن اختيارك سيرافقك طوال المستوى"
  },

  challenge: {
    loading: "جاري تحميل المستوى...",
    peace: "🕊️ ليحل السلام في بيتك",
    questionsAwaiting: "🎯 3 أسئلة معرفية تنتظرك",
    starsQuote: "كل نجمة خطوة نحو النور الإلهي"
  },

  chapters: {
    "1": "سفر التكوين",
    "2": "سفر الخروج",
    "3": "يسوع المسيح",
    "4": "الصلب/القيامة",
    "5": "الكنيسة الأولى",
    "6": "رسالات بولس",
    "7": "الرسائل/الرؤيا",
    "8": "مستوى إضافي"
  },

  bible: {
    readerTitle: "📖 قارئ الكتاب المقدس",
    loading: "جاري تحميل الكتب المقدسة...",
    menu: "القائمة",
    strong: "Strong",
    strongReferences: "مراجع Strong",
    verses: "آيات",
    previous: "السابق",
    next: "التالي",
    strongDefinition: "مرجع Strong",
    word: "الكلمة الأصلية",
    transliteration: "النقحرة",
    pronunciation: "النطق",
    meaning: "المعنى",
    definition: "التعريف الكامل",
    usage: "الاستخدام الكتابي",
    etymology: "أصل الكلمة",
    close: "إغلاق",
    moreReferences: "و {{count}} مراجع أخرى",
    copyright: "📖 Smith & Van Dyke 1865 - ملكية عامة • أرقام Strong مضمنة"
  },

  philosophy: {
    title: "البعد الفلسفي",
    loveOntology: "الحب كمبدأ وجودي",
    loveDescription: "يحول يسوع الحب إلى أساس ميتافيزيقي: محبة الله والقريب تصبح البنية ذاتها للوجود الأصيل. يتجاوز الحب الأخلاق ليصبح طريقة للوجود.",
    newCommandment: "الوصية الجديدة",
    jesusEmphasizes: "عندما يعطي يسوع وصية جديدة، يؤكد على فعل المحبة",
    loveGod: "أحب الله من كل قلبك",
    loveNeighbor: "أحب قريبك كنفسك",
    lovePriority: "تصبح المحبة أولوية"
  },

  footer: {
    version: "الإصدار 1.0 • 2024",
    dedication: "تم التطوير لمجد الله"
  },

  endCredits: {
    lines: [
      { text: "لقد وصلت إلى قمة الجبل", delay: 2000 },
      { text: "لقد تعلمت الكثير من الأشياء", delay: 2000 },
      { text: "إيمانك ينمو كل يوم", delay: 2000 },
      { text: "تعيش أشياء جميلة مع الله", delay: 2000 },
      { text: "الصعوبات تساعدك على النمو", delay: 2000 },
      { text: "تظهر ما هو مهم", delay: 2000 },
      { text: "كن متواضعاً مثل طفل صغير", delay: 2000 },
      { text: "الله يحب قلبك البسيط", delay: 2000 },
      { text: "في الهدوء تسمع الله", delay: 2000 },
      { text: "الصوم يحرر روحك", delay: 2000 },
      { text: "صلي وسيرشدك الله", delay: 2000 },
      { text: "الكبرياء يخفي الحقيقة", delay: 2000 },
      { text: "نعمة الله عظيمة", delay: 2000 },
      { text: "تأتي من قلب الله", delay: 2000 },
      { text: "الإيمان الحقيقي يحررك", delay: 2000 },
      { text: "يوحدك مع الله إلى الأبد", delay: 2000 },
      { text: "الحب يمكن أن يغير كل شيء", delay: 2000 },
      { text: "يمكن أن يصنع المعجزات", delay: 2000 },
      { text: "كرر معي", delay: 2000 },
      { text: "يسوع، أعطيك قلبي", delay: 3000 },
      { text: "أنت ملكي، مخلصي", delay: 3000 },
      { text: "تعال وحول حياتي", delay: 3000 },
      { text: "الرحلة تستمر الآن", delay: 2000 },
      { text: "شارك هذا النور الجميل", delay: 2000 },
      { text: "نحو الحياة التي لا تنتهي أبداً", delay: 2000 },
      { text: "احفظ الحب في قلبك", delay: 3000 },
      { text: "مثل كنز ثمين", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "تهانينا!",
      proud: "نحن فخورون بك",
      courage: "محارب شجاع",
      peace: "حامل السلام",
      child: "طفل الله",
      blessing: "ليباركك الله",
      continue: "متابعة"
    }
  },

  mountain: {
    spiritualAscension: "الصعود الروحي",
    levelProgress: "المستوى {{level}} • {{stars}} نجوم تم الحصول عليها",
    combo: "كومبو",
    perfectMessage: "\"لأن أفكاري ليست أفكاركم\" - الحمل يصعد نحو الحكمة الكاملة",
    goodMessage: "\"اطلبوا تجدوا\" - الصعود يستمر نحو الحقيقة",
    startMessage: "\"الإيمان، حتى لو كان صغيرًا مثل حبة الخردل\" - الخطوة الأولى نحو النور",
    skipAnimation: "تخطي الرسوم المتحركة",
    chapter: "فصل",
    chapterProgress: "فصل {{current}}/{{total}}",
    secret: "سر",
    waypoints: {
      start: "البداية",
      firstSlope: "المنحدر الأول",
      lastSlope: "المنحدر الأخير"
    },
    status: {
      defeat: "هزيمة",
      inProgress: "قيد التقدم",
      victory: "نصر"
    }
  },

  validation: {
    pseudoTooShort: "يجب أن يحتوي اسم المستخدم على حرفين على الأقل",
    enterPseudo: "الرجاء إدخال اسم المستخدم"
  },

  pseudoSetup: {
    title: "اختر اسم المستخدم",
    confirm: "تأكيد الاسم"
  },

  navigation: {
    back: "رجوع"
  },

  console: {
    starsUnlocked: "النجوم تم الوصول إليها! فتح الفصل",
    defeatAnimation: "هزيمة... ينزل المسيح"
  },

  errors: {
    progressionError: "خطأ في التقدم",
    invalidProgressionData: "بيانات تقدم غير صالحة:"
  },

  levels: {
    chaptersAndBonus: "8 فصول + مستوى إضافي",
    bonusUnlocked: "🏆 تم فتح المستوى الإضافي! لقد وصلت إلى الكمال الروحي!",
    starsToDiscover: "273 {stars} لاكتشافها",
    starsPerLevel: "3 {stars} لكل مستوى"
  },

  architecture: {
    title: "🔧 البنية التقنية",
    react: {
      name: "React",
      description: "واجهة حديثة"
    },
    modules: {
      name: "الوحدات",
      description: "التحميل الديناميكي"
    },
    localStorage: {
      name: "التخزين المحلي",
      description: "التخزين المحلي"
    },
    tailwind: {
      name: "Tailwind",
      description: "تصميم متجاوب"
    }
  },

  info: {
    title: "Unity Quest سجلات السلام",
    subtitle: "اكتشاف تفاعلي للكتب المقدسة",
    yourStats: "إحصائياتك",
    score: "النقاط",
    wisdom: "الحكمة",
    revelation: "الوحي",
    createdWith: "صُنع بـ ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "مطور شغوف بالروحانية",
    artistModule: "Emmanuel الفنان",
    artistPortfolio: "محفظة فنية وإبداعات رقمية",
    features: "الميزات",
    multipleChapters: "91 مستوى موزعة على 8 فصول من الكتاب المقدس",
    powerCards: "3 بطاقات قوة فريدة (الإيمان، الشجاعة، الحكمة)",
    progressionSystem: "نظام تقدم مع رتب روحية",
    bibleTreasures: "كنوز من الكتاب المقدس وحقائق مثيرة",
    howToPlay: "كيف تلعب",
    selectLevel: "اختر مستوى مفتوح",
    choosePowerCard: "اختر بطاقة القوة الخاصة بك",
    answerQuestions: "أجب على 3 أسئلة معرفية",
    earnStars: "احصل على نجوم حسب الأرواح المتبقية",
    tips: "نصائح",
    readCarefully: "اقرأ كل سؤال بعناية",
    useWisdomCard: "استخدم بطاقة الحكمة للحصول على تلميحات",
    courageGivesSecondChance: "بطاقة الشجاعة تمنحك فرصة ثانية",
    faithMaximizes: "بطاقة الإيمان تزيد نقاطك إلى الحد الأقصى",
    johnGospelTitle: "إنجيل يوحنا",
    johnGospelStats: "21 فصل • 878 آية • 14 لغة",
    bibleReaderStrong: "قارئ الكتاب المقدس + Strong",
    bibleReaderStrongDesc: "قراءة كاملة مع قاموس Strong",
    johnTreasures: "كنوز يوحنا",
    johnTreasuresDesc: "كنوز الكتاب المقدس وحقائق مثيرة",
    quickAccessChapters: "الوصول السريع إلى الفصول الشهيرة:",
    johnChapter1: "المقدمة",
    johnChapter3: "الولادة الجديدة",
    johnChapter14: "أنا الطريق",
    johnChapter20: "القيامة",
    version: "الإصدار",
    madeWithLove: "صُنع بحب لمجد الله",
    backToMenu: "العودة للقائمة"
  },

  bible: {
    readerTitle: "📖 قارئ الكتاب المقدس",
    johnReaderTitle: "قارئ الكتاب المقدس - إنجيل يوحنا",
    john: "يوحنا",
    loading: "جارٍ تحميل الكتاب المقدس...",
    loadingChapter: "الفصل {chapter} من إنجيل يوحنا. البيانات الكاملة قيد التحميل...",
    exploreWhileLoading: "في هذه الأثناء، يمكنك استكشاف فصول أخرى أو استخدام وظيفة البحث.",
    menu: "القائمة",
    tabBible: "الكتاب المقدس",
    tabUnity: "الوحدة",
    strong: "Strong",
    strongReferences: "مراجع Strong",
    verses: "آيات",
    previous: "السابق",
    next: "التالي",
    strongDefinition: "مرجع Strong",
    word: "الكلمة الأصلية",
    transliteration: "النقحرة",
    close: "إغلاق",
    share: "مشاركة",
    shareVerse: "شارك هذه الآية",
    shareSelection: "شارك التحديد",
    pronunciation: "النطق",
    meaning: "المعنى",
    definition: "التعريف الكامل",
    usage: "الاستخدام في الكتاب المقدس",
    etymology: "أصل الكلمة",
    search: "بحث...",
    definitionNotFound: "لم يتم العثور على التعريف",
    definitionLoading: "جارٍ تحميل التعريف...",
    imageFeatureComing: "🖼️ ميزة الصور قريباً!",
    copyError: "خطأ في النسخ:",
    error: "❌ خطأ",
    errorLoading: "خطأ في التحميل",
    retry: "أعد المحاولة",
    readerInDevelopment: "قارئ إنجيل يوحنا قيد التطوير...",
    verseCopied: "تم نسخ الآية إلى الحافظة!",
    moreReferences: "و {{count}} مراجع أخرى",
    copyright: "📖 LSG 1910 • Strong مضمن",
    markAsRead: "المقطع مقروء",
    alreadyRead: "تم القراءة",
    readingBonus: "مكافأة القراءة",
    results: "نتائج",
    result: "نتيجة",
    copy: "نسخ",
    image: "صورة"
  },

  mountain: {
    chapter: "فصل",
    secret: "سر!",
    spiritualAscension: "الصعود الروحي",
    levelProgress: "المستوى {{level}} • {{stars}} نجمة محققة",
    combo: "كومبو",
    perfectMessage: '"لأن أفكاري ليست أفكاركم" - الحمل يصعد نحو الحكمة الكاملة',
    goodMessage: '"اطلبوا تجدوا" - الصعود يستمر نحو الحقيقة',
    startMessage: '"الإيمان، حتى لو كان صغيراً كحبة خردل" - الخطوة الأولى نحو النور',
    skipAnimation: "تخطي الحركة",
    stats: {
      points: "نقط",
      level: "مستوى"
    },
    waypoints: {
      start: "البداية",
      firstSlope: "المنحدر الأول",
      lastSlope: "المنحدر الأخير"
    },
    status: {
      victory: "النصر!",
      defeat: "الهزيمة",
      inProgress: "قيد التقدم"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "اقرأ في التطبيق",
      description: "قارئ الكتاب المقدس المدمج مع Strong",
      features: {
        offline: "غير متصل",
        strong: "أرقام Strong",
        navigation: "التنقل"
      }
    }
  },

  quotes: {
    wisdom: "المعرفة الحقيقية تؤدي إلى الحكمة الأبدية",
    faith: "أستطيع كل شيء في المسيح الذي يقويني",
    hope: "الرب راعي فلا يعوزني شيء",
    love: "لأنه هكذا أحب الله العالم...",
    perseverance: "الإيمان يتطلب المثابرة",
    defeat: "الفشل يدعو للنمو في المعرفة"
  },

  philosophy: {
    title: "البعد الفلسفي",
    loveOntology: "الحب كمبدأ وجودي",
    loveDescription: "يسوع يحول الحب إلى أساس ميتافيزيقي: محبة الله والقريب تصبح البنية ذاتها للوجود الأصيل. الحب يتجاوز الأخلاق ليصبح طريقة للوجود.",
    newCommandment: "الوصية الجديدة",
    jesusEmphasizes: "عندما يعطي يسوع وصية جديدة، يؤكد على فعل الحب",
    loveGod: "أحب الله بكل قلبك",
    loveNeighbor: "أحب قريبك كنفسك",
    lovePriority: "الحب يصبح أولوية"
  },

  unity: unityTranslations,

  footer: {
    version: "الإصدار 1.0 • 2024",
    dedication: "تم التطوير لمجد الله"
  },

  endCredits: {
    lines: [
      { text: "لقد وصلت إلى قمة الجبل", delay: 2000 },
      { text: "لقد تعلمت الكثير", delay: 2000 },
      { text: "إيمانك ينمو كل يوم", delay: 2000 },
      { text: "تعيش أشياء جميلة مع الله", delay: 2000 },
      { text: "الصعوبات تساعدك على النمو", delay: 2000 },
      { text: "إنها تظهر ما هو مهم", delay: 2000 },
      { text: "كن متواضعاً كطفل", delay: 2000 },
      { text: "الله يحب قلبك البسيط", delay: 2000 },
      { text: "في الهدوء تسمع الله", delay: 2000 },
      { text: "الصوم يحرر روحك", delay: 2000 },
      { text: "صلِّ والله سيرشدك", delay: 2000 },
      { text: "الكبرياء يخفي الحقيقة", delay: 2000 },
      { text: "نعمة الله رائعة", delay: 2000 },
      { text: "إنها تأتي من قلب الله", delay: 2000 },
      { text: "الإيمان الحقيقي يحررك", delay: 2000 },
      { text: "يوحدك بالله إلى الأبد", delay: 2000 },
      { text: "المحبة يمكن أن تغير كل شيء", delay: 2000 },
      { text: "يمكنها صنع المعجزات", delay: 2000 },
      { text: "ردد معي", delay: 2000 },
      { text: "يا يسوع، أعطيك قلبي", delay: 3000 },
      { text: "أنت ملكي، مخلصي", delay: 3000 },
      { text: "تعال وحول حياتي", delay: 3000 },
      { text: "الطريق يستمر الآن", delay: 2000 },
      { text: "شارك هذا النور الجميل", delay: 2000 },
      { text: "نحو الحياة التي لا تنتهي أبداً", delay: 2000 },
      { text: "احفظ الحب في قلبك", delay: 3000 },
      { text: "ككنز ثمين", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "مبروك!",
      proud: "نحن فخورون بك",
      courage: "شجاعة بطولية",
      peace: "حامل السلام",
      child: "ابن الله",
      blessing: "ليباركك الله",
      continue: "استمر"
    }
  },

  validation: {
    pseudoTooShort: "يجب أن يحتوي الاسم المستعار على حرفين على الأقل",
    enterPseudo: "الرجاء إدخال اسم مستعار"
  },

  pseudoSetup: {
    title: "اختر اسمك المستعار للعبة",
    profileConfig: "تكوين الملف الشخصي",
    connectedWith: "متصل مع",
    playerPseudo: "الاسم المستعار للاعب",
    pseudoPlaceholder: "اسمك المستعار...",
    pseudoRequirements: "2-20 حرفاً • يظهر في التصنيفات",
    suggestions: "اقتراحات",
    confirm: "تأكيد الاسم المستعار",
    errorConfig: "خطأ في التكوين"
  },

  navigation: {
    back: "رجوع"
  },

  console: {
    starsUnlocked: "نجوم محققة! فتح الفصل",
    defeatAnimation: "الهزيمة... ي.م. ينزل"
  },

  errors: {
    progressionError: "خطأ في التقدم",
    invalidProgressionData: "بيانات تقدم غير صالحة:"
  },

  levels: {
    chaptersAndBonus: "8 فصول + مستوى إضافي",
    bonusUnlocked: "🎊 المستوى الإضافي مفتوح! لقد وصلت إلى الكمال الروحي!",
    starsToDiscover: "273 {stars} لاكتشافها",
    starsPerLevel: "3 {stars} لكل مستوى"
  },

  architecture: {
    title: "🏗️ البنية التقنية",
    react: {
      name: "React",
      description: "واجهة حديثة"
    },
    modules: {
      name: "الوحدات",
      description: "التحميل الديناميكي"
    },
    localStorage: {
      name: "LocalStorage",
      description: "الحفظ المحلي"
    },
    tailwind: {
      name: "Tailwind",
      description: "تصميم متجاوب"
    }
  },

  gameManager: {
    title: "حفظ اللعبة",
    saveLocal: "حفظ محلي",
    saveCloud: "السحابة متزامنة",
    saveWaiting: "في انتظار الاتصال",
    lastSave: "آخر حفظ:",
    never: "أبداً",
    saving: "جارٍ الحفظ...",
    save: "حفظ",
    loadProgress: "تحميل",
    loading: "جارٍ التحميل...",
    autoSaveEnabled: "💾 الحفظ التلقائي مفعّل",
    saveError: "❌ خطأ في الحفظ",
    gameSaved: "✅ تم حفظ اللعبة!",
    gameLoaded: "📥 تم تحميل اللعبة!"
  }
};

export default uiTranslations;
